import { HttpParams } from '@angular/common/http';

/** Representa o Filter para pesquisar os Item */
export class TabelaPrecoFilterSearch {
    filterPsq: string;
    situacao: number;
    idRepresentante: number;
    moeda: number;
    exportacao: boolean = null;


    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Filtro de Pesquisa
        if (this.filterPsq) {
            params = params.append('filterPsq', this.filterPsq);
        }
        // Situação
        if (this.situacao) {
            params = params.append('situacao', this.situacao.toString());
        }
        // Representante
        if (this.idRepresentante) {
            params = params.append('idRepresentante', this.idRepresentante.toString());
        }
        // Moeda
        if (this.moeda) {
            params = params.append('moeda', this.moeda.toString());
        }
        // Exportação
        if (this.exportacao != null && this.exportacao !== undefined) {
            params = params.append('exportacao', this.exportacao.toString());
        }

        return params;
    }

    clear() {
        this.filterPsq = null;
        this.situacao = null;
        this.idRepresentante = null;
        this.moeda = null;
        this.exportacao = null;
    }
}

